<template>
  	<div id="coinAdaList">
  		<mt-header fixed :title="$t('选择币种')">
		  	<mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
		</mt-header>
		<div ref="main_list" class="main_list">
            <ul class="content_detail main_show">
                <li v-for="(item,index) in CoinsList" style="position: relative;">
                    <div @click="CoinName(item.id,item.coin_symbol,item.img_url,item.cloud_balance,item.display_coin_symbol)">
                        <img v-bind:src="item.img_url" alt="" class="oImg">
                        <span class="currency_name">
                            <span class="receive wx_fontSize3">{{item.display_coin_symbol}}</span>
                            <span class="form wx_fontSize2">{{item.coin_name}}</span>
                        </span>
                    </div>
                </li>
            </ul>
		</div>
  	</div>
</template>
<script>
import { httpFromCoins , httpToCoins } from "@/api/index";
import { Toast } from "mint-ui";
export default {
    data(){
        return{
            access:'',
            CoinsList:[],
            coin_symbol:''
        }
    },
    activated(){
        this.access = this.$route.query.access;
        this.coin_symbol = this.$route.query.coin_symbol;
        if(this.access == 'to'){
            this.toList();
        }else if(this.access == 'from'){
            this.formList();
        }
    },
    methods:{
        formList(){
            httpFromCoins({})
            .then(res => {
                this.CoinsList = [];
                this.CoinsList = res.data.list;
            })
            .catch(() => {});
        },
        toList(){
            httpToCoins({'from_coin':this.coin_symbol})
            .then(res => {
                this.CoinsList = [];
                this.CoinsList = res.data.list;
                if(this.CoinsList.length == 0){
                    Toast(this.$t('暂无数据'))
                }
            })
            .catch(() => {});
        },
        CoinName(id,name,img_url,cloud_balance,display_name){
            this.name = {name:name,id:id,img_url:img_url,cloud_balance:cloud_balance,access:this.access,display_name:display_name};
            this.$router.go(-1)
        }
    },
    beforeRouteLeave(to, from, next) {
        // {path:"/addAddress",query:{name:name,id:id}}
        to.query.result = this.name;
        next();
    }
}
</script>

<style scoped>
#coinAdaList{width:100%;height:100%;}
.mint-header{background: transparent;color:#212529;border-bottom: 1px solid #e3e8ed;}
.mint-button--default{color:#656b79 !important;}
.main_list{padding:40px 15px 0 15px;}
.main_show{width:100%;}
.childList{width:80%;margin-left: 20%;display:none;}
.content_detail li{width:100%;background:#fff;border-bottom:1px solid #e3e8ed;}
.oImg{width:40px;height:40px;margin:10px 14px 9px 0px;border:1px solid #dddddd;border-radius: 50%;margin-left: 10px;}
.currency_name{position: relative;display: inline-block;top:-34px;}
.receive{position: absolute;top:0;}
.form{position: relative;top:25px;color:#8c92a8;}
.amount_of{width:20%;text-align: right;padding:5px 0;border:1px solid #1296db;text-align: center;margin-top: 17px;color:#1296db;}
</style>